


















































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {IInterface, ITag} from '../shared/services/models/Interface';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import {ICPUInfo, INicBuffers, IServer, ISystemBuffers, ISystemMemory, IProcess, IGPUProcess } from '../shared/services/models/Server';
import {ISetting} from '../shared/services/models/Setting';


// The @Component decorator indicates the class is a Vue component
@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['serverStatus', 'settings', 'interfaces']),
    },
    methods: {
        ...mapActions(['updateInterfaces', 'stopInterface', 'forceStopInterface']),
    },
})
export default class ServerComponent extends Vue {
    private serverStatus!: IServer;
    private settings!: ISetting[];
    private interfaces!: IInterface[];

    private updateInterval: any = null;

    private InterfaceFields: any[] = [
        { key: 'nr', sortable: true },
        { key: 'name', sortable: true },
        { key: 'cpu', labelnv   : 'CPU', sortable: true },
        { key: 'memory', sortable: true },
        { key: 'pid', label: 'PID', sortable: true },
        { key: 'gpu', label: 'GPU memory', sortable: true },
        { key: 'actions', label: ''},
    ];

    private mounted() {
        // @ts-ignore
        this.updateInterfaces();
        this.updateInterval = setInterval(() => {
            // @ts-ignore
            this.updateInterfaces();
        }, 5000);
    }

    private unmounted() {
        if (this.updateInterval !== null) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    }

    private get ServerStatus(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        this.serverStatus.cpu.forEach((c) => {
            if (c && c.length === 11 && c[0] === 'all') {
                ret[`idle`] = c[10];
            }
        });
        return ret;
    }

    private get CPUInfo(): ICPUInfo {
        return this.serverStatus.cpu_info;
    }

    private get Interfaces(): any[] {
        const ret: any[] = [];

        this.interfaces.forEach((i) => {
            const p: IProcess | null = this.getProcess(i.id);
            const g: IGPUProcess | null = this.getGPUProcess(p);
            ret.push({
                id: i.id,
                nr: i.nr,
                name: i.name,
                cpu: p !== null ? `${p.cpu}%` : undefined,
                memory: p !== null ? `${(p.memory / 1024).toFixed(2)} MB` : undefined,
                pid: p !== null ? p.pid : undefined,
                gpu: g !== null ? g.used_gpu_memory : undefined,
                active: i.state === 1,
                _rowVariant: this.getProcessStatus(p),
            });
        });
        return ret;
    }

    private get SensorTiles(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        try {
            Object.keys(this.serverStatus.sensors).forEach((element) => {
                Object.keys(this.serverStatus.sensors[element]).forEach((key) => {
                    if (key.toLowerCase().indexOf('core') !== -1 && typeof this.serverStatus.sensors[element][key] !== 'string') {

                        Object.keys(this.serverStatus.sensors[element][key]).forEach((temp) => {
                            if (typeof temp === 'string' && temp.indexOf('_input') !== -1 && temp.indexOf('temp') !== -1) {
                                ret[key] = this.serverStatus.sensors[element][key][temp];
                            }
                        });
                    }
                });
            });
        } catch (E) {
            window.console.log('Error in showing sensors', E);
        }
        return ret;
    }

    private get MemoryStatusTiles(): ISystemMemory {
        return this.serverStatus.memory;
    }

    private get CPUStatusTitles(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        this.serverStatus.cpu.forEach((c) => {
            if (c && c.length === 11 && c[0] === 'CPU') {
                ret[`Core`] = '';
               /* ret[`${c[1].replace('%', '')}`] = '';
                ret[`${c[2].replace('%', '')}`] = '';
                ret[`${c[3].replace('%', '')}`] = '';
                ret[`${c[10].replace('%', '')}`] = '';*/
                ret[`Load`] = '';
            }
        });
        return ret;
    }

    private get CPUStatus(): { [key: string]: string[] } {
        const ret: { [key: string]: string[] } = {};

        this.serverStatus.cpu.forEach((c) => {
            if (c && c.length === 11 && c[0] !== 'all' && c[0] !== 'CPU') {
                ret[`#${c[0]}`] = [];
                ret[`#${c[0]}`].push('#' + c[0]);
               /* ret[`#${c[0]}`].push(c[1]);
                ret[`#${c[0]}`].push(c[2]);
                ret[`#${c[0]}`].push(c[3]);*/
                ret[`#${c[0]}`].push((100 - parseFloat(c[10])).toFixed(1) + '%');
            }
        });
        return ret;
    }

    private get GPUStatus(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        if (this.serverStatus && this.serverStatus.gpu_info) {
            this.serverStatus.gpu_info.forEach((c) => {
                Object.keys(c).forEach((gi: string) => {
                    switch (gi) {
                        case 'power_draw': ret[`Power`] = c[gi]; break;
                        case 'utilization_gpu': ret[`Utilization`] = c[gi]; break;
                        case 'fan_speed': ret[`Fan speed`] = c[gi]; break;
                        case 'temperature_gpu': ret[`Temperature`] = c[gi] + '&deg;C'; break;
                        case 'memory_used': ret[`Memory (used)`] = c[gi]; break;
                        case 'memory_total': ret[`Memory (total)`] = c[gi]; break;
                        case 'memory_free': ret[`Memory (free)`] = c[gi]; break;
                        case 'name': ret[`Model`] = c[gi]; break;
                    }
                });
            });
        }
        return ret;
    }

    private get NicBuffers(): { [key: string]: INicBuffers } {
        if (this.serverStatus) {
            return this.serverStatus.net_buffers;
        }

        return {};
    }

     private get RPFilter(): { [key: string]: string } {
        if (this.serverStatus) {
            return this.serverStatus.rp_filter;
        }

        return {};
    }

    private get SytemBuffers(): ISystemBuffers {
        if (this.serverStatus) {
            return this.serverStatus.buffers;
        }

        return {
            mem_max: -1,
            wmem_max: -1,
            mem_default: -1,
            wmem_default: -1,
            optmem_max: -1,
            netdev_max_backlog: -1,
        };
    }

    private get ServerInfo(): { [key: string]: string } {
        if (this.serverStatus) {
            return this.serverStatus.server_info;
        }

        return {};
    }

    private get CPUGovernor(): { [key: number]: string } {
        if (this.serverStatus) {
            return this.serverStatus.cpu_governor;
        }

        return {};
    }

    private getProcess(id: string): IProcess | null {
        for (const p of this.serverStatus.processes) {
            if (p.id === id) {
                return p;
            }
        }
        return null;
    }

    private getGPUProcess(p: IProcess | null): IGPUProcess | null {
        if (p) {
            const pid: string = `${p.pid}`;

            for (const pr of this.serverStatus.gpu_processes) {
                if (pr.pid === pid) {
                    return pr;
                }
            }
        }

        return null;
    }

    private getProcessStatus(p: IProcess | null): string | undefined {
        if (p) {
            if (p.cpu > 150 || p.memory > (1024 * 1024)) {
                return 'danger';
            } else if (p.cpu >= 100 || p.memory > (100 * 1024)) {
                return 'warning';
            }
        }
        return undefined;
    }

    private stop(id: string, name: string, nr: number): void {
        // @ts-ignore
        this.$bvModal.msgBoxConfirm(`Stop ${name}`, {
            title: 'Stop Interface',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                // @ts-ignore
                this.stopInterface({id, nr});
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }

    private forceStop(id: string, name: string, nr: number): void {
        // @ts-ignore
        this.$bvModal.msgBoxConfirm(`Force stop ${name}, only to be used when normal stop fails`, {
            title: 'Force Stop of Interface',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        .then((value) => {
            if (value) {
                // @ts-ignore
                this.forceStopInterface({id, nr});
            }
        })
        .catch((err) => {
            // An error occurred
        });
    }
}
